/**
 * 视讯静默登录的一次性凭据交接
 *
 * goProvider() (MainLobbyMobile.vue) 调 useLiveGamePlay().enterLive() 拿到视讯账号密码后,
 * 存在这里再跳去 /live/login；该页面 onMounted 取出后立刻清空，走现有 USLO00 登录，
 * 跳过手动表单。全程只存在 JS 模块内存里，不落 localStorage/sessionStorage，
 * 也不经过任何会被持久化的 Pinia store。
 */
export interface PendingLiveLogin {
  username: string
  password: string
  h5Url: string
}

let pending: PendingLiveLogin | null = null

export function setPendingLiveLogin(v: PendingLiveLogin): void {
  pending = v
}

/** 一次性取出并立刻清空: 用完即弃, 避免残留凭据被下一次挂载误用 */
export function takePendingLiveLogin(): PendingLiveLogin | null {
  const v = pending
  pending = null
  return v
}

/**
 * 只探测是否有待处理的静默登录凭据, 不取出/不清空。
 *
 * 给 router.beforeEach 里 `to.name === 'live-login'` 的守卫用: 用来区分
 * "enterLiveAndGo() 正常跳转进来" (有凭据在排队, 什么都不用清理, 直接放行)
 * 和 "浏览器后退/心跳超时/被踢下线等异常落到这个路由" (没有凭据, 说明不是
 * 正常入口, 见 router/index.ts 的守卫处理)。
 */
export function hasPendingLiveLogin(): boolean {
  return pending !== null
}

/**
 * 当前视讯会话的 session_id, 跨组件/路由共享。
 *
 * useLiveGamePlay() 里的 sessionId 是组合式函数的局部 ref —— MainLobbyMobile.vue 调
 * enterLive() 拿到 session_id 后, 页面会一路跳到 /live/login → /live/home 等完全不同的
 * 组件树, 中途再调 useLiveGamePlay() (比如退出登录按钮所在的 Navbar.vue/SettingsSidebar.vue)
 * 拿到的是全新的组合式函数实例, 局部 ref 是空的, exitLive() 会因为 sid 为空直接被短路掉。
 * 这里用模块级变量存, 从 launch 拿到一直到 exitLive() 真正调用退出接口才清空。
 */
let liveSessionId = ''

export function setLiveSessionId(id: string): void {
  liveSessionId = id
}

export function getLiveSessionId(): string {
  return liveSessionId
}

export function clearLiveSessionId(): void {
  liveSessionId = ''
}
